import { render, staticRenderFns } from "./FormEditarCodigos.vue?vue&type=template&id=5d35c8da"
import script from "./FormEditarCodigos.vue?vue&type=script&lang=js"
export * from "./FormEditarCodigos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports